import { useAuth } from "../../../../contexts/AuthContext";
import React, { useState, useRef } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import Search from "../../../shares/search/Search";
import {
  AccountCircleTwoTone,
  GroupsOutlined,
  UploadFileOutlined,
  AddRounded,
} from "@mui/icons-material";
import { Modal } from "@mui/material";
import useFetch from "../../../../hooks/useFetch";
import useMutation from "../../../../hooks/useMutation";
import { managementService } from "../../../../api/services/management";
import { endpoints } from "../../../../api/endpoints";
import { Link, useSearchParams } from "react-router-dom";
import AddVideos from "./modals/AddVideos";
import { toast } from "react-toastify";
import { PageHeader } from "../../../shares/dashboard/DashboardWidgets";

const Students = () => {
  const { user } = useAuth();
  const [importKind, setImportKind] = useState("student");
  const [newModal, setNewModal] = useState(false);
  const [questions, setQuestion] = useState();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClose = () => {
    setNewModal(false);
  };

  const getQuestion = useFetch({
    method: "GET",
    safeRead: true,
    url: endpoints.management.users,
    params: { page: searchParams.get("page") ?? 1, search: searchParams.get("search") ?? "" },
    noHeader: false,
    trigger: true,
    setter: setQuestion,
  });

  const importReq = useMutation();
  const handleImport = async (file) => {
    if (!file || (importKind === "management" && user?.role !== "superuser")) return;
    const data = new FormData(); data.append("file", file);
    const result = await importReq.run((signal) => managementService.importAccounts(data, signal));
    if (result) { toast.success("کاربران با موفقیت بارگذاری شدند."); getQuestion.reFetch(); }
  };

  const columns = [
    { id: "username", label: "کدملی" },
    { id: "first_name", label: "نام" },
    { id: "last_name", label: "نام خانوادگی" },
    {
      id: "student_school",
      label: "مدرسه",
      render: (row) => row.studentuser?.student_school,
    },
    {
      id: "groups",
      label: "گروه",
      render: (row) =>
        row.groups?.[0]?.name ? (
          <span className="rounded-pill bg-surface-sunken px-md py-2xs text-xs text-ink-muted">
            {row.groups[0].name}
          </span>
        ) : (
          <span className="text-ink-subtle">—</span>
        ),
    },
    {
      id: "profile",
      label: "پروفایل",
      render: (row) => (
        <Link
          to={`${row.id}`}
          aria-label="مشاهده پروفایل دانش‌آموز"
          className="inline-flex h-[3.2rem] w-[3.2rem] items-center justify-center rounded-soft text-ink-muted transition-colors duration-150 hover:bg-primary-soft hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
        >
          <AccountCircleTwoTone sx={{ fontSize: "2rem" }} />
        </Link>
      ),
    },
  ];

  const questionRef = useRef(null);

  const handleClickQuestion = () => {
    questionRef.current.click();
  };

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="دانش‌آموزان"
        description="فهرست دانش‌آموزان، بارگذاری گروهی و مدیریت پروفایل"
        icon={GroupsOutlined}
      >
        <div className="flex shrink-0 flex-wrap items-center gap-sm">
          <label>نوع فایل حساب‌ها <select value={importKind} disabled={importReq.busy} onChange={(event) => setImportKind(event.target.value)}>
            <option value="student">دانش‌آموزان</option>
            {user?.role === "superuser" && <option value="management">حساب‌های مدیریتی</option>}
          </select></label>
          <button
            type="button"
            onClick={handleClickQuestion}
            disabled={importReq.busy}
            className="inline-flex items-center gap-2xs rounded-soft border border-rule bg-surface px-lg py-sm text-base text-ink-muted transition-colors duration-150 hover:bg-surface-sunken hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            <UploadFileOutlined sx={{ fontSize: "1.8rem" }} />
            {importReq.busy ? "در حال بارگذاری…" : "بارگذاری اکسل"}
          </button>
          <input
            type="file"
            ref={questionRef}
            accept=".xlsx,.xls"
            onChange={(e) => { if (importKind === "management" && user?.role !== "superuser") return; handleImport(e.target.files[0]); e.target.value = ""; }}
            required
            style={{ display: "none" }}
          />
          <button
            type="button"
            onClick={() => setNewModal(true)}
            className="inline-flex items-center gap-2xs rounded-soft bg-primary px-lg py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
          >
            <AddRounded sx={{ fontSize: "1.8rem" }} />
            افزودن دانش‌آموز
          </button>
        </div>
      </PageHeader>

      <div className="flex flex-col gap-lg">
        {user?.role !== "superuser" && <p>فقط فایل دانش‌آموزان را بارگذاری کنید. ایجاد حساب مدیریتی از اکسل ویژه مدیر ارشد است.</p>}
        {importReq.error && <p role="alert" className="text-danger">{importReq.error}</p>}
        <Search getFiltered={getQuestion} />

        <ShareTable
          data={questions?.results ?? []}
          columns={columns}
          getPage={getQuestion}
          totalCount={questions?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddVideos close={handleClose} get={getQuestion} />
      </Modal>
    </div>
  );
};

export default Students;
